@import '../../../global//scss/form/mixins';

go-fieldset {
  display: block;
  fieldset {
    padding: 0;
    border: none;
    legend {
      @include label-wrapper;
    }
    .fieldset-content {
      display: grid;
      gap: var(--input-gap-inner);
      @include unstyled-list;
    }
  }

  .go-field {
    margin-top: 0;
  }
}
